import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./style.css";
import "swiper/css";
import "swiper/css/navigation";

import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const DestinationImages = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="destination-images container">
      <p className="title">Study Destination</p>
      <h2 className="subtitle">Countries We Focus On</h2>
      <div className="destination-details-container">
        <div className="destination-details">
          <Swiper
            slidesPerView={1}
            spaceBetween={25}
            grabCursor={true}
            navigation={true}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            speed={500}
            modules={[Navigation, Autoplay]}
            className="mySwiper"
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
            }}
          >
            <SwiperSlide>
              <Link to="/study-in-uk" onClick={scrollHeader}>
                <div className="card card-uk">
                  <h1>United Kingdom</h1>
                </div>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/study-in-australia" onClick={scrollHeader}>
                <div className="card card-australia">
                  <h1>Australia</h1>
                </div>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/study-in-japan" onClick={scrollHeader}>
                <div className="card card-japan">
                  <h1>Japan</h1>
                </div>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/study-in-canada" onClick={scrollHeader}>
                <div className="card card-canada">
                  <h1>Canada</h1>
                </div>
              </Link>
            </SwiperSlide>
            <SwiperSlide>
              <Link to="/study-in-usa" onClick={scrollHeader}>
                <div className="card card-usa">
                  <h1>USA</h1>
                </div>
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default DestinationImages;
